import { generateLanguageQuery } from '@/services/dataStore/queries/fragments'

const observationIconProjection = `
  _id,
  "altText": ${generateLanguageQuery('altText')},
  "imageURL": imageFile.asset->url,
`

export const observationIconsQuery = () => `*[_type == "observationIcon"] {
  ${observationIconProjection}
}`

export const observationIconQuery = (
  key: string
) => `*[_type == "observationIcon" && _id == "${key}"] {
  ${observationIconProjection}
}`
